import React from 'react';
import PropTypes from 'prop-types';

import { RELATIVE } from '../../../../../constants';

export default class Item extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...props };
  }

  render() {
    const {
      country, cases, flagURL, param, period, quality,
    } = this.props;
    const casesParam = [period, param].join(' ');
    return (
      <div>
        <div className="statistics__item row">
          <img className="flag" src={flagURL} alt="Flag" />
          <div className="country">{country}</div>
          <div className="cases">{cases}</div>
          <div className="casesParam">{casesParam}</div>
          {(quality === RELATIVE) ? <span className="quality">(per 100.000)</span> : null }
        </div>
      </div>
    );
  }
}

Item.propTypes = {
  country: PropTypes.string.isRequired,
  cases: PropTypes.string.isRequired,
  flagURL: PropTypes.string.isRequired,
  param: PropTypes.string.isRequired,
  period: PropTypes.string.isRequired,
  quality: PropTypes.string.isRequired,
};
